import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { APTypography, IAPTypography } from '@astropay/web-core-library';
import { Link, LinkProps } from '@material-ui/core';

interface ApLinkToProps extends LinkProps, IAPTypography {
  to: string;
}

const ApLinkTo: FC<ApLinkToProps> = ({ to, text, textStyle, ...linkProps }) => {
  return (
    <Link component={RouterLink} to={to} {...linkProps}>
      <APTypography textStyle={textStyle}>{text}</APTypography>
    </Link>
  );
};

export default ApLinkTo;
